import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

export const CONTENT_DEFAULTS = {
  brand_name: "LocalLease",
  hero_overline: "The complete rental toolkit",
  hero_title: "List, lease & manage homes — all in one place.",
  hero_subtitle:
    "LocalLease gives independent landlords everything to fill vacancies: beautiful listings, online applications, e-signed leases, card & ACH payments, and a maintenance portal renters actually enjoy using.",
  hero_cta_primary: "Browse Homes",
  hero_cta_secondary: "List Your Property",
  hero_image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&q=85",
  hero_badge_label: "Rent collected via",
  hero_badge_value: "Card & ACH transfer",
  features_overline: "Everything included",
  features_heading: "One platform from first showing to signed lease.",
  feature_1_title: "Apply & E-Sign",
  feature_1_desc: "Custom online applications and legally-styled lease agreements signed in minutes.",
  feature_2_title: "Schedule Showings",
  feature_2_desc: "Renters request tours and landlords confirm times — no phone tag required.",
  feature_3_title: "Rent & Deposits",
  feature_3_desc: "Collect application fees, deposits, and monthly rent by card or ACH bank transfer.",
  feature_4_title: "Maintenance Portal",
  feature_4_desc: "Track repair requests from open to resolved with photos and status updates.",
  feature_5_title: "Direct Messaging",
  feature_5_desc: "A private channel between every landlord and renter, all in one place.",
  feature_6_title: "Instant Notifications",
  feature_6_desc: "Landlords get pinged the moment rent is paid or a request comes in.",
  featured_overline: "Available now",
  featured_heading: "Featured homes",
  browse_overline: "Find your next home",
  browse_title: "Browse available rentals",
  footer_tagline: "© 2026 LocalLease. Rentals made effortless.",
};

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(CONTENT_DEFAULTS);

  useEffect(() => {
    api.get("/content").then((r) => setContent({ ...CONTENT_DEFAULTS, ...r.data })).catch(() => {});
  }, []);

  const c = useCallback((key) => (content[key] ?? CONTENT_DEFAULTS[key] ?? ""), [content]);

  const value = useMemo(() => ({ content, c }), [content, c]);

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext) || { content: CONTENT_DEFAULTS, c: (k) => CONTENT_DEFAULTS[k] ?? "" };
